    <template>


        <div id="list">
            <div class="container" >
                <div class="row">
                    <h1  class="title is-1" >Veel gestelde vragen</h1>

                </div>
            </div>

            <collapse v-for="post in posts" :key="post.id" v-bind:post="post"></collapse>
        </div>
    </template>
<script>
    import axios from 'axios'
    import Collapse from '../global/Collapse.vue'

    export default {
        name: 'FAQ',
        data() {
            return {
                isActive: false,
                posts: []
            }
        },

        metaInfo: function() {
            return {
                title: "Yoursource" + " - Veel gestelde vragen.",
                meta: [
                    {
                        name: 'description', content: "uw partner op het gebied van bedrijfsadvisering en automatisering.",
                    },
                    {
                        name: 'keywords', content: "Yoursource, Exact, Software, Orbis, Crm, Hrm, Microsoft"
                    }
                ]
            }
        },

        created() {
            let postsUrl =  this.apiUrl + '/wp-json/wp/v2/faqs';
            axios
                .get(postsUrl)
                .then(response => {
                    this.posts = response.data
                    // console.log(response.data)
                })
            document.title = 'Veel gestelde vragen';
        },

        components: {
            'collapse': Collapse
        }
    }
</script>